import uiStateKeys from '../../../support/uiStateKeys';
import { type QueryKeyRoot } from '../queryKeyRoots';

// The load query is prefixed with the modal-teardown key so it is cleared on
// modal close; `root` is the partial key used for invalidation/cache reads. The
// 'onLoad' root sits at index 1, after the teardown prefix.
export const LOAD_QUERY_KEYS = {
  root: () =>
    [
      uiStateKeys.REMOVE_QUERY_ON_MODAL_CLOSE,
      'onLoad',
    ] as const satisfies readonly [string, QueryKeyRoot, ...unknown[]],
  onLoad: (assetId?: string, assetType?: string, genId?: string | null) =>
    [
      uiStateKeys.REMOVE_QUERY_ON_MODAL_CLOSE,
      'onLoad',
      assetId,
      assetType,
      genId,
    ] as const satisfies readonly [string, QueryKeyRoot, ...unknown[]],
} as const;
